// extracted by mini-css-extract-plugin
export default {"alertInbox":"_138GngE0rIq-awv8VBizNg==","badge":"wXfpT+y34cuApqJrgqvb4w=="};